import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Select } from 'antd';
import authHeader from "../../services/auth-header";
import _db, { getTruckingCompanies, getUserTerminal, getBookedEquipment, getLinesWithPositiveRemainder, isRF } from "../../services/kiosque-service";
import AuthService from "../../services/auth.service";

import 'antd/dist/antd.css';

const ERROR_CLASS = '.is-invalid';
const user = AuthService.getCurrentUser();

const StepOne = ({ formData, updateFormData, navigate }) => {
    const { t } = useTranslation();
    const { Option } = Select;

    const { truckingCompany, truckNumber, licencePlate } = formData;
    const [truckingCompanies, setTruckingCompanies] = useState([]);

    //Load on startup
    useEffect(() => {
        let isMounted = true;

        async function getTruckingCompaniesData() { 
            try {
                const companiesList = await getTruckingCompanies();

                if (isMounted) {
                    setTruckingCompanies(companiesList);
                }

            } catch (error) {
                console.error("Erreur inattendue dans le composant !", error);
                if (isMounted) {
                    setTruckingCompanies([]); 
                }
            }
        }

        getTruckingCompaniesData(); 

        return () => {
            isMounted = false; // Nettoyage
        };
    }, []); 
    
    useEffect(() => {
        let isMounted = true; 

        if (isMounted && truckingCompany && truckingCompanies.length > 0) { 
            const transport = truckingCompanies.find((w) => w.id === truckingCompany);
            updateFormData({ transport });
        }

        return () => {
            isMounted = false; 
        };
    }, [truckingCompany]);

    useEffect(() => {
        let isMounted = true;

        async function getUserTerminalData(userCode) {
            try {
                const terminal = await getUserTerminal(userCode);

                if (isMounted) {
                    updateFormData({ user: user.userName, terminal });
                }

            } catch (error) {
                // Ce catch n'est techniquement plus n�cessaire
                console.error("Erreur inattendue dans le composant:", error);
            }
        }

        if (user.userName) {
            getUserTerminalData(user.userName);
        }

        return () => {
            isMounted = false;
        };
    }, [user.userName]); 

    const getBookData = async (bookNumber) => {
        try {
            let url = "/api/kiosqueGetBookData";
            const response = await _db.get(url, { headers: authHeader(), params: { bookNumber } });

            const bookDetails = response.data;

            return { success: true, book: bookDetails }; 
        } catch (error) {
            console.error("Erreur lors de la r�cup�ration du booking :", error);

            // On extrait le message d'erreur de l'API 
            const errorMessage = error.response?.data || "Erreur inconnue";

            return { success: false, book: {}, errorMessage: errorMessage };
        }
    };

    function focusFirstErrorField() {
        const firstFieldWithError = document.querySelector(ERROR_CLASS);

        if (firstFieldWithError) {
            firstFieldWithError.focus();
        }       
    }

    const handleChange = (e) => {
        updateFormData({ [e.target.name]: e.target.value.trim().toUpperCase() });
        //const { name, value } = e.target;
        //updateFormData({ [name]: value.toUpperCase() });
    };

    const handleTruckingCompanyChange = (value) => {
        updateFormData({ truckingCompany: value });
    };

    const handleNext = async (e) => {
        e.preventDefault();

        if (!formData.user || !formData.terminal) {
            updateFormData({ errorMessage: "UNKNOWN_USER_OR_TERMINAL_MSG" });
            navigate(8);
            return
        } 

        const valide = await validateStepOne(); // On ramene success et les infos sur le booking
        if (!valide.success) {
            requestAnimationFrame(focusFirstErrorField)
            return;
        }

        const bookDetails = valide.book; 
        const isBundleBooking = valide.book.bundle;

        const bookedItems = await getBookedEquipment(formData.bookNumber);
        if (!bookedItems) {
            updateFormData({ errorMessage: "NO_EQUIPMENT_MSG" });
            navigate(8);
            return;
        }

        const availableLines = getLinesWithPositiveRemainder(bookedItems);

        const hasGenset = availableLines.some(item => {
            return item.size === "GENSET";
        });

        const gensetLine = availableLines.find(item => item.size === "GENSET");    // 1. Extraire la ligne du genset ()
        const otherLines = availableLines.filter(item => item.size !== "GENSET");  // 2. Extraire le reste du tableau (les lignes ne contenant pas le genset)

        // 1. S'il n'ya plus �quipement dont le remainder >0 (msg d'erreur)
        if (availableLines.length <= 0) {
            updateFormData({ errorMessage: "NO_EQUIPMENT_MSG" });
            navigate(8);
            return; 
        }

        // � partir d'ici, nous savons que availableLines.length > 0

        // 2. Sinon, si on a un bundle (gestion du bundle)
        if (isBundleBooking) {
            updateFormData({ bookData: bookDetails, bookedEquipment: bookedItems, isBundle: true, line: bookedItems[0] });
            navigate(2);
            return; 
        }

        // � partir d'ici, nous savons que ce n'est PAS un bundle et qu'il y a des �quipements.

        // 3. Sinon, si on a une ligne unique ou 2 ligne (une ligne avec un genset) (Sc�nario 1)
        const hasOneLineOrOneWithGenset = availableLines.length === 1 || (availableLines.length === 2 && hasGenset);

        if (hasOneLineOrOneWithGenset) {
            let data = {};

            if (availableLines.length === 1) {
                data = { ...data, bookData: bookDetails, bookedEquipment: bookedItems, isBundle: false, line: availableLines[0] }
            } else {
                // Logique pour 2 lignes
                if (isRF(otherLines[0])) {
                    data = { ...data, bookData: bookDetails, bookedEquipment: bookedItems, isBundle: false, attachGenset: true, genset: gensetLine, line: otherLines[0] }
                } else {
                    data = { ...data, bookData: bookDetails, bookedEquipment: bookedItems, isBundle: false, attachGenset: false, genset: {}, line: otherLines[0] }
                }
            }

            updateFormData(data);
            navigate(4);

            return; 
        }

        // 4. Enfin, si on a plusieurs lignes (Sc�nario 2 : choix manuel n�cessaire, on va aller � etape 3 pour choisir line)
        updateFormData({ bookData: bookDetails, bookedEquipment: bookedItems, isBundle: false });
        navigate(3);
    };

    const handleBookingKeyPress = (e) => {
        if (e.key === 'Enter' && e.target.value.length > 0) {
            handleNext(e)
        }
    }

    /* ************* VALIDATION ******************** */
    const [errors, setErrors] = useState({ "truckingCompany": '', truckNumber: '', licencePlate: '' , "bookNumber": '' });
    const validateStepOne = async () => {
        let valid = true;
        const errorsCopy = { ...errors };

        let res
        if ((formData.bookNumber != null) && (formData.bookNumber.trim())) {            
            res = await getBookData(formData.bookNumber);
        }        

        if (formData.truckingCompany == null || (!formData.truckingCompany.trim())) {
            errorsCopy.truckingCompany = 'selectTruckingCompanyError'; // Just put the key, and t('key') will be done in the error message component.
            valid = false;
        }
        else {
            errorsCopy.truckingCompany = '';
        }

        if (truckNumber == null || (!truckNumber.trim())) {
            errorsCopy.truckNumber = 'enterTruckNumberError'; 
            valid = false;
        }
        else {
            errorsCopy.truckNumber = '';
        }

        if (licencePlate == null || (!licencePlate.trim())) {
            errorsCopy.licencePlate = 'enterLicencePlateError';
            valid = false;
        }
        else {
            errorsCopy.licencePlate = '';
        }

        if (formData.bookNumber == null || (!formData.bookNumber.trim())) {
            errorsCopy.bookNumber = 'enterBookNumberError';
            valid = false;
        }
        else if (!res.success) {
            errorsCopy.bookNumber = 'incorrectNumberOrInvalidBooking'; 
            valid = false;
        }
        else {
            errorsCopy.bookNumber = '';
        }

        setErrors(errorsCopy);
        return { success: valid, book: res?.book };
    }
    /* ************* END VALIDATION **************** */

    //console.log("setp 1...", formData);

    return (
        <form onSubmit={handleNext} className="kform">
            <div className="text-end fw-bold fs-4 mb-3">Pre-Interchange</div>

            <div className="mb-2">
                <label className="klabel fw-bold">{t('truckingCompany')}</label>
                <div className={`d-inline ${errors.truckingCompany ? 'ant-select-error' : ''}`}>                    
                    <Select
                        showSearch
                        optionFilterProp="children"
                        size="large"
                        allowClear={true}
                        placeholder={t('truckingCompany')}
                        name="truckingCompany"
                        value={formData.truckingCompany}
                        className={`w-100 p-0 ${errors.truckingCompany ? 'is-invalid' : ''}`}
                        onChange={handleTruckingCompanyChange}
                    >
                        {/*<Option value={undefined}></Option>*/}
                        {truckingCompanies.map(item => (<Option key={item.id} value={item.id}>{item.transport1}</Option>))}
                    </Select>
                    {errors.truckingCompany && <div className="invalid-feedback">{t(errors.truckingCompany)}</div>}
                    {/*{errors.truckingCompany && <div className="invalid-feedback">{errors.truckingCompany}</div>}*/}
                </div>
            </div>

            <div className="mb-2">
                <label className="klabel fw-bold">{t('truckNumber')}</label>
                <input
                    type="text"
                    name="truckNumber"
                    value={formData.truckNumber || ''}
                    className={`form-control d-inline w-100 ${errors.truckNumber ? 'is-invalid' : ''}`}
                    onChange={handleChange}                        
                />
                {errors.truckNumber && <div className="invalid-feedback">{t(errors.truckNumber)}</div>}
            </div>

            <div className="mb-2">
                <label className="klabel fw-bold">{t('licencePlate')}</label>
                <input
                    type="text"
                    name="licencePlate"
                    value={formData.licencePlate || ''}
                    className={`form-control d-inline w-100 ${errors.licencePlate ? 'is-invalid' : ''}`}
                    onChange={handleChange}
                />
                {errors.licencePlate && <div className="invalid-feedback">{t(errors.licencePlate)}</div>}
            </div>
            <div className="mb-3">
                <label className="klabel fw-bold">{t('bookingNumber')}</label>
                <input
                    type="text"
                    name="bookNumber"
                    value={formData.bookNumber || ''}
                    className={`form-control d-inline w-100 text-center ${errors.bookNumber ? 'is-invalid' : ''}`}
                    onChange={handleChange}
                    onKeyPress={handleBookingKeyPress}
                />
                {errors.bookNumber && <div className="invalid-feedback">{t(errors.bookNumber)}</div>}
                </div>
           
                <div className="d-flex justify-content-between">
                    <button type="button" className="btn btn-secondary fw-bold px-3 py-2" disabled>LIFT IN</button>
                    <button type="submit" className="btn btn-primary fw-bold px-3 py-2">LIFT OUT</button>
                </div>                
        </form>
    );
};

export default StepOne;